import axios from 'axios';
import config from '../../config';
import { getUserToken } from '../../utils/helpers';

export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_FAIL = 'GET_PROJECTS_FAIL';
export const GET_PROJECTS_RESET = 'GET_PROJECTS_RESET';

export const CREATE_PROJECT = 'CREATE_PROJECT';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_FAIL = 'CREATE_PROJECT_FAIL';
export const CREATE_PROJECT_RESET = 'CREATE_PROJECT_RESET';

export const GET_PROJECT_BY_ID = 'GET_PROJECT_BY_ID';
export const GET_PROJECT_BY_ID_SUCCESS = 'GET_PROJECT_BY_ID_SUCCESS';
export const GET_PROJECT_BY_ID_FAIL = 'GET_PROJECT_BY_ID_FAIL';
export const GET_PROJECT_BY_ID_RESET = 'GET_PROJECT_BY_ID_RESET';

export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_FAIL = 'UPDATE_PROJECT_FAIL';
export const UPDATE_PROJECT_RESET = 'UPDATE_PROJECT_RESET';

export const DELETE_PROJECT = 'DELETE_PROJECT';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAIL = 'DELETE_PROJECT_FAIL';
export const DELETE_PROJECT_RESET = 'DELETE_PROJECT_RESET';

export const GET_PROJECT_FILES = 'GET_PROJECT_FILES';
export const GET_PROJECT_FILES_SUCCESS = 'GET_PROJECT_FILES_SUCCESS';
export const GET_PROJECT_FILES_FAIL = 'GET_PROJECT_FILES_FAIL';
export const GET_PROJECT_FILES_RESET = 'GET_PROJECT_FILES_RESET';

export const UPLOAD_PROJECT_FILE = 'UPLOAD_PROJECT_FILE';
export const UPLOAD_PROJECT_FILE_SUCCESS = 'UPLOAD_PROJECT_FILE_SUCCESS';
export const UPLOAD_PROJECT_FILE_FAIL = 'UPLOAD_PROJECT_FILE_FAIL';
export const UPLOAD_PROJECT_FILE_RESET = 'UPLOAD_PROJECT_FILE_RESET';

export const DELETE_PROJECT_FILE = 'DELETE_PROJECT_FILE';
export const DELETE_PROJECT_FILE_SUCCESS = 'DELETE_PROJECT_FILE_SUCCESS';
export const DELETE_PROJECT_FILE_FAIL = 'DELETE_PROJECT_FILE_FAIL';
export const DELETE_PROJECT_FILE_RESET = 'DELETE_PROJECT_FILE_RESET';

export const GENERATE_UPLOAD_URLS = 'GENERATE_UPLOAD_URLS';
export const GENERATE_UPLOAD_URLS_SUCCESS = 'GENERATE_UPLOAD_URLS_SUCCESS';
export const GENERATE_UPLOAD_URLS_FAIL = 'GENERATE_UPLOAD_URLS_FAIL';
export const GENERATE_UPLOAD_URLS_RESET = 'GENERATE_UPLOAD_URLS_RESET';

export const BULK_UPLOAD_PROGRESS = 'BULK_UPLOAD_PROGRESS';
export const BULK_UPLOAD_COMPLETE = 'BULK_UPLOAD_COMPLETE';
export const BULK_UPLOAD_RESET = 'BULK_UPLOAD_RESET';

export const getProjects = (params) => ({
  type: GET_PROJECTS,
  params,
});

export const getProjectsSuccess = (response) => ({
  type: GET_PROJECTS_SUCCESS,
  response,
});

export const getProjectsFail = (response) => ({
  type: GET_PROJECTS_FAIL,
  response,
});

export const getProjectsReset = () => ({
  type: GET_PROJECTS_RESET,
});

export const createProject = (params) => ({
  type: CREATE_PROJECT,
  params,
});

export const createProjectSuccess = (response) => ({
  type: CREATE_PROJECT_SUCCESS,
  response,
});

export const createProjectFail = (response) => ({
  type: CREATE_PROJECT_FAIL,
  response,
});

export const createProjectReset = () => ({
  type: CREATE_PROJECT_RESET,
});

export const getProjectById = (params) => ({
  type: GET_PROJECT_BY_ID,
  params,
});

export const getProjectByIdSuccess = (response) => ({
  type: GET_PROJECT_BY_ID_SUCCESS,
  response,
});

export const getProjectByIdFail = (response) => ({
  type: GET_PROJECT_BY_ID_FAIL,
  response,
});

export const getProjectByIdReset = () => ({
  type: GET_PROJECT_BY_ID_RESET,
});

export const updateProject = (params) => ({
  type: UPDATE_PROJECT,
  params,
});

export const updateProjectSuccess = (response) => ({
  type: UPDATE_PROJECT_SUCCESS,
  response,
});

export const updateProjectFail = (response) => ({
  type: UPDATE_PROJECT_FAIL,
  response,
});

export const updateProjectReset = () => ({
  type: UPDATE_PROJECT_RESET,
});

export const deleteProject = (params) => ({
  type: DELETE_PROJECT,
  params,
});

export const deleteProjectSuccess = (response) => ({
  type: DELETE_PROJECT_SUCCESS,
  response,
});

export const deleteProjectFail = (response) => ({
  type: DELETE_PROJECT_FAIL,
  response,
});

export const deleteProjectReset = () => ({
  type: DELETE_PROJECT_RESET,
});

export const getProjectsApi = (data) => {
  return (dispatch) => {
    dispatch(getProjects());
    axios
      .get(`${config.api.base_url}/projects`, {
        params: data,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const getProjectsData = response.data;
        dispatch(getProjectsSuccess(getProjectsData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(getProjectsFail(error.response?.data || errorMsg));
      });
  };
};

export const createProjectApi = (data) => {
  return (dispatch) => {
    dispatch(createProject());
    axios
      .post(`${config.api.base_url}/projects`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const createProjectData = response.data;
        dispatch(createProjectSuccess(createProjectData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(createProjectFail(error.response?.data || errorMsg));
      });
  };
};

export const getProjectByIdApi = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_BY_ID });
    axios
      .get(`${config.api.base_url}/projects/${id}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const getProjectByIdData = response.data;
        dispatch(getProjectByIdSuccess(getProjectByIdData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(getProjectByIdFail(error.response?.data || errorMsg));
      });
  };
};

export const updateProjectApi = (id, data) => {
  return (dispatch) => {
    dispatch(updateProject());
    axios
      .post(`${config.api.base_url}/projects/${id}`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const updateProjectData = response.data;
        dispatch(updateProjectSuccess(updateProjectData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(updateProjectFail(error.response?.data || errorMsg));
      });
  };
};

export const deleteProjectApi = (id) => {
  return (dispatch) => {
    dispatch(deleteProject());
    axios
      .post(`${config.api.base_url}/projects/delete/${id}`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        const deleteProjectData = response.data;
        dispatch(deleteProjectSuccess(deleteProjectData));
      })
      .catch((error) => {
        const errorMsg = error.message;
        dispatch(deleteProjectFail(error.response?.data || errorMsg));
      });
  };
};

export const getProjectFilesSuccess = (response) => ({
  type: GET_PROJECT_FILES_SUCCESS,
  response,
});

export const getProjectFilesFail = (response) => ({
  type: GET_PROJECT_FILES_FAIL,
  response,
});

export const getProjectFilesReset = () => ({
  type: GET_PROJECT_FILES_RESET,
});

export const uploadProjectFileSuccess = (response) => ({
  type: UPLOAD_PROJECT_FILE_SUCCESS,
  response,
});

export const uploadProjectFileFail = (response) => ({
  type: UPLOAD_PROJECT_FILE_FAIL,
  response,
});

export const uploadProjectFileReset = () => ({
  type: UPLOAD_PROJECT_FILE_RESET,
});

export const deleteProjectFileSuccess = (response) => ({
  type: DELETE_PROJECT_FILE_SUCCESS,
  response,
});

export const deleteProjectFileFail = (response) => ({
  type: DELETE_PROJECT_FILE_FAIL,
  response,
});

export const deleteProjectFileReset = () => ({
  type: DELETE_PROJECT_FILE_RESET,
});

export const getProjectFilesApi = (projectId, params = {}) => {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_FILES });
    axios
      .get(`${config.api.base_url}/projects/${projectId}/files`, {
        params,
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getProjectFilesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getProjectFilesFail(error.response?.data || error.message));
      });
  };
};

export const uploadProjectFileApi = (projectId, file) => {
  return (dispatch) => {
    dispatch({ type: UPLOAD_PROJECT_FILE });
    const formData = new FormData();
    formData.append('file', file);
    axios
      .post(`${config.api.base_url}/projects/${projectId}/files`, formData, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        dispatch(uploadProjectFileSuccess(response.data));
      })
      .catch((error) => {
        dispatch(uploadProjectFileFail(error.response?.data || error.message));
      });
  };
};

export const deleteProjectFileApi = (projectId, fileId) => {
  return (dispatch) => {
    dispatch({ type: DELETE_PROJECT_FILE });
    axios
      .post(`${config.api.base_url}/projects/${projectId}/files/${fileId}/delete`, {}, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(deleteProjectFileSuccess(response.data));
      })
      .catch((error) => {
        dispatch(deleteProjectFileFail(error.response?.data || error.message));
      });
  };
};

export const downloadProjectFileApi = (projectId, fileId, fileName) => {
  return () => {
    return axios
      .get(`${config.api.base_url}/projects/${projectId}/files/${fileId}/download`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then(async (response) => {
        if (response.data?.data?.downloadUrl) {
          try {
            // Fetch the actual file content from the signed URL
            const fileResponse = await fetch(response.data.data.downloadUrl);
            const blob = await fileResponse.blob();

            // Create download from blob
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = fileName || 'download';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } catch (fetchError) {
            console.error('Failed to fetch file content:', fetchError);
            // Fallback to opening in new tab if fetch fails
            window.open(response.data.data.downloadUrl, '_blank');
          }
        }
        return response;
      })
      .catch((error) => {
        console.error('Download failed:', error);
        throw error;
      });
  };
};

export const generateUploadUrlsSuccess = (response) => ({
  type: GENERATE_UPLOAD_URLS_SUCCESS,
  response,
});

export const generateUploadUrlsFail = (response) => ({
  type: GENERATE_UPLOAD_URLS_FAIL,
  response,
});

export const generateUploadUrlsReset = () => ({
  type: GENERATE_UPLOAD_URLS_RESET,
});

export const bulkUploadProgress = (progress) => ({
  type: BULK_UPLOAD_PROGRESS,
  progress,
});

export const bulkUploadComplete = (response) => ({
  type: BULK_UPLOAD_COMPLETE,
  response,
});

export const bulkUploadReset = () => ({
  type: BULK_UPLOAD_RESET,
});

export const generateUploadUrlsApi = (projectId, files, batchTag = null) => {
  return (dispatch) => {
    dispatch({ type: GENERATE_UPLOAD_URLS });
    return axios
      .post(
        `${config.api.base_url}/projects/${projectId}/files/generate-upload-urls`,
        { files, batchTag },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch(generateUploadUrlsSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(generateUploadUrlsFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const confirmBatchUploadApi = (projectId, results) => {
  return () => {
    return axios
      .post(
        `${config.api.base_url}/projects/${projectId}/files/confirm-batch-upload`,
        { results },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error('Confirm batch upload failed:', error);
        throw error;
      });
  };
};

export const uploadFilesToCloud = (projectId, files, options = {}) => {
  return async (dispatch) => {
    try {
      const fileMetadata = files.map((file) => ({
        fileName: file.name,
        fileSize: file.size,
        mimeType: file.type,
      }));

      const urlResponse = await dispatch(generateUploadUrlsApi(projectId, fileMetadata, options.batchTag));

      if (!urlResponse?.data?.uploadUrls) {
        throw new Error('Failed to generate upload URLs');
      }

      const { uploadUrls } = urlResponse.data;
      const CONCURRENT_UPLOADS = options.concurrentUploads || 10;

      const uploadQueue = [...uploadUrls];
      const results = [];
      let activeUploads = 0;
      let completedCount = 0;
      let failedCount = 0;

      const uploadFileToCloud = async (file, signedUrl) => {
        const headers = {
          'Content-Type': file.type,
        };

        if (signedUrl.includes('blob.core.windows.net')) {
          headers['x-ms-blob-type'] = 'BlockBlob';
        }

        await axios.put(signedUrl, file, { headers });
      };

      return new Promise((resolve, reject) => {
        const processNext = () => {
          if (uploadQueue.length === 0 && activeUploads === 0) {
            dispatch(confirmBatchUploadApi(projectId, results))
              .then((confirmResponse) => {
                dispatch(bulkUploadComplete(confirmResponse));
                resolve(confirmResponse);
              })
              .catch((error) => {
                dispatch(generateUploadUrlsFail(error.message));
                reject(error);
              });
            return;
          }

          while (activeUploads < CONCURRENT_UPLOADS && uploadQueue.length > 0) {
            const uploadInfo = uploadQueue.shift();
            const file = files.find((f) => f.name === uploadInfo.fileName);

            if (!file) {
              results.push({ fileId: uploadInfo.fileId, status: 'failed', error: 'File not found' });
              failedCount++;
              dispatch(
                bulkUploadProgress({
                  completed: completedCount,
                  failed: failedCount,
                  total: uploadUrls.length,
                  percentage: Math.round(((completedCount + failedCount) / uploadUrls.length) * 100),
                })
              );
              processNext();
              continue;
            }

            activeUploads++;

            uploadFileToCloud(file, uploadInfo.uploadUrl)
              .then(() => {
                results.push({ fileId: uploadInfo.fileId, status: 'completed' });
                completedCount++;
              })
              .catch((error) => {
                results.push({
                  fileId: uploadInfo.fileId,
                  status: 'failed',
                  error: error.message,
                });
                failedCount++;
              })
              .finally(() => {
                activeUploads--;

                dispatch(
                  bulkUploadProgress({
                    completed: completedCount,
                    failed: failedCount,
                    total: uploadUrls.length,
                    percentage: Math.round(((completedCount + failedCount) / uploadUrls.length) * 100),
                  })
                );

                processNext();
              });
          }
        };

        processNext();
      });
    } catch (error) {
      dispatch(generateUploadUrlsFail(error.message));
      throw error;
    }
  };
};

export const getIndexingStatusApi = (projectId) => {
  return () => {
    return axios
      .get(`${config.api.base_url}/projects/${projectId}/indexing-status`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error('Get indexing status failed:', error);
        throw error;
      });
  };
};

export const reindexFilesApi = (projectId, fileIds = null) => {
  return () => {
    return axios
      .post(
        `${config.api.base_url}/projects/${projectId}/reindex`,
        { fileIds },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error('Reindex files failed:', error);
        throw error;
      });
  };
};

export const regenerateProjectContextApi = (projectId) => {
  return () => {
    return axios
      .post(
        `${config.api.base_url}/projects/${projectId}/regenerate-context`,
        {},
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => {
        console.error('Regenerate project context failed:', error);
        throw error;
      });
  };
};

export const UPDATE_PROJECT_SETTINGS = 'UPDATE_PROJECT_SETTINGS';
export const UPDATE_PROJECT_SETTINGS_SUCCESS = 'UPDATE_PROJECT_SETTINGS_SUCCESS';
export const UPDATE_PROJECT_SETTINGS_FAIL = 'UPDATE_PROJECT_SETTINGS_FAIL';
export const UPDATE_PROJECT_SETTINGS_RESET = 'UPDATE_PROJECT_SETTINGS_RESET';

// Project Sharing
export const GET_PROJECT_SHARES = 'GET_PROJECT_SHARES';
export const GET_PROJECT_SHARES_SUCCESS = 'GET_PROJECT_SHARES_SUCCESS';
export const GET_PROJECT_SHARES_FAIL = 'GET_PROJECT_SHARES_FAIL';
export const GET_PROJECT_SHARES_RESET = 'GET_PROJECT_SHARES_RESET';

export const SHARE_PROJECT = 'SHARE_PROJECT';
export const SHARE_PROJECT_SUCCESS = 'SHARE_PROJECT_SUCCESS';
export const SHARE_PROJECT_FAIL = 'SHARE_PROJECT_FAIL';
export const SHARE_PROJECT_RESET = 'SHARE_PROJECT_RESET';

export const UPDATE_PROJECT_SHARE = 'UPDATE_PROJECT_SHARE';
export const UPDATE_PROJECT_SHARE_SUCCESS = 'UPDATE_PROJECT_SHARE_SUCCESS';
export const UPDATE_PROJECT_SHARE_FAIL = 'UPDATE_PROJECT_SHARE_FAIL';
export const UPDATE_PROJECT_SHARE_RESET = 'UPDATE_PROJECT_SHARE_RESET';

export const REMOVE_PROJECT_SHARE = 'REMOVE_PROJECT_SHARE';
export const REMOVE_PROJECT_SHARE_SUCCESS = 'REMOVE_PROJECT_SHARE_SUCCESS';
export const REMOVE_PROJECT_SHARE_FAIL = 'REMOVE_PROJECT_SHARE_FAIL';
export const REMOVE_PROJECT_SHARE_RESET = 'REMOVE_PROJECT_SHARE_RESET';

export const updateProjectSettingsSuccess = (response) => ({
  type: UPDATE_PROJECT_SETTINGS_SUCCESS,
  response,
});

export const updateProjectSettingsFail = (response) => ({
  type: UPDATE_PROJECT_SETTINGS_FAIL,
  response,
});

export const updateProjectSettingsReset = () => ({
  type: UPDATE_PROJECT_SETTINGS_RESET,
});

export const updateProjectSettingsApi = (projectId, data) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PROJECT_SETTINGS });
    return axios
      .post(`${config.api.base_url}/projects/${projectId}`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(updateProjectSettingsSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(updateProjectSettingsFail(error.response?.data || error.message));
        throw error;
      });
  };
};

// Project Sharing Action Creators
export const getProjectSharesSuccess = (response) => ({
  type: GET_PROJECT_SHARES_SUCCESS,
  response,
});

export const getProjectSharesFail = (response) => ({
  type: GET_PROJECT_SHARES_FAIL,
  response,
});

export const getProjectSharesReset = () => ({
  type: GET_PROJECT_SHARES_RESET,
});

export const shareProjectSuccess = (response) => ({
  type: SHARE_PROJECT_SUCCESS,
  response,
});

export const shareProjectFail = (response) => ({
  type: SHARE_PROJECT_FAIL,
  response,
});

export const shareProjectReset = () => ({
  type: SHARE_PROJECT_RESET,
});

export const updateProjectShareSuccess = (response) => ({
  type: UPDATE_PROJECT_SHARE_SUCCESS,
  response,
});

export const updateProjectShareFail = (response) => ({
  type: UPDATE_PROJECT_SHARE_FAIL,
  response,
});

export const updateProjectShareReset = () => ({
  type: UPDATE_PROJECT_SHARE_RESET,
});

export const removeProjectShareSuccess = (response) => ({
  type: REMOVE_PROJECT_SHARE_SUCCESS,
  response,
});

export const removeProjectShareFail = (response) => ({
  type: REMOVE_PROJECT_SHARE_FAIL,
  response,
});

export const removeProjectShareReset = () => ({
  type: REMOVE_PROJECT_SHARE_RESET,
});

// Project Sharing API Actions
export const getProjectSharesApi = (projectId) => {
  return (dispatch) => {
    dispatch({ type: GET_PROJECT_SHARES });
    return axios
      .get(`${config.api.base_url}/projects/${projectId}/shares`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getProjectSharesSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(getProjectSharesFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const shareProjectApi = (projectId, data) => {
  return (dispatch) => {
    dispatch({ type: SHARE_PROJECT });
    return axios
      .post(`${config.api.base_url}/projects/${projectId}/share`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(shareProjectSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(shareProjectFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const updateProjectShareApi = (projectId, userId, data) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PROJECT_SHARE });
    return axios
      .put(`${config.api.base_url}/projects/${projectId}/share/${userId}`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(updateProjectShareSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(updateProjectShareFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const removeProjectShareApi = (projectId, userId) => {
  return (dispatch) => {
    dispatch({ type: REMOVE_PROJECT_SHARE });
    return axios
      .delete(`${config.api.base_url}/projects/${projectId}/share/${userId}`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(removeProjectShareSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(removeProjectShareFail(error.response?.data || error.message));
        throw error;
      });
  };
};

// Campaign to Project Actions
export const GET_ELIGIBLE_CAMPAIGNS = 'GET_ELIGIBLE_CAMPAIGNS';
export const GET_ELIGIBLE_CAMPAIGNS_SUCCESS = 'GET_ELIGIBLE_CAMPAIGNS_SUCCESS';
export const GET_ELIGIBLE_CAMPAIGNS_FAIL = 'GET_ELIGIBLE_CAMPAIGNS_FAIL';
export const GET_ELIGIBLE_CAMPAIGNS_RESET = 'GET_ELIGIBLE_CAMPAIGNS_RESET';

export const CREATE_PROJECT_FROM_CAMPAIGN = 'CREATE_PROJECT_FROM_CAMPAIGN';
export const CREATE_PROJECT_FROM_CAMPAIGN_SUCCESS = 'CREATE_PROJECT_FROM_CAMPAIGN_SUCCESS';
export const CREATE_PROJECT_FROM_CAMPAIGN_FAIL = 'CREATE_PROJECT_FROM_CAMPAIGN_FAIL';
export const CREATE_PROJECT_FROM_CAMPAIGN_RESET = 'CREATE_PROJECT_FROM_CAMPAIGN_RESET';

export const getEligibleCampaignsSuccess = (response) => ({
  type: GET_ELIGIBLE_CAMPAIGNS_SUCCESS,
  response,
});

export const getEligibleCampaignsFail = (response) => ({
  type: GET_ELIGIBLE_CAMPAIGNS_FAIL,
  response,
});

export const getEligibleCampaignsReset = () => ({
  type: GET_ELIGIBLE_CAMPAIGNS_RESET,
});

export const createProjectFromCampaignSuccess = (response) => ({
  type: CREATE_PROJECT_FROM_CAMPAIGN_SUCCESS,
  response,
});

export const createProjectFromCampaignFail = (response) => ({
  type: CREATE_PROJECT_FROM_CAMPAIGN_FAIL,
  response,
});

export const createProjectFromCampaignReset = () => ({
  type: CREATE_PROJECT_FROM_CAMPAIGN_RESET,
});

export const getEligibleCampaignsApi = () => {
  return (dispatch) => {
    dispatch({ type: GET_ELIGIBLE_CAMPAIGNS });
    return axios
      .get(`${config.api.base_url}/projects/campaigns/eligible`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getEligibleCampaignsSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(getEligibleCampaignsFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const createProjectFromCampaignApi = (data) => {
  return (dispatch) => {
    dispatch({ type: CREATE_PROJECT_FROM_CAMPAIGN });
    return axios
      .post(`${config.api.base_url}/projects/from-campaign`, data, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(createProjectFromCampaignSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(createProjectFromCampaignFail(error.response?.data || error.message));
        throw error;
      });
  };
};

// Import from Studies Actions
export const GET_ELIGIBLE_STUDIES = 'GET_ELIGIBLE_STUDIES';
export const GET_ELIGIBLE_STUDIES_SUCCESS = 'GET_ELIGIBLE_STUDIES_SUCCESS';
export const GET_ELIGIBLE_STUDIES_FAIL = 'GET_ELIGIBLE_STUDIES_FAIL';
export const GET_ELIGIBLE_STUDIES_RESET = 'GET_ELIGIBLE_STUDIES_RESET';

export const IMPORT_FROM_STUDIES = 'IMPORT_FROM_STUDIES';
export const IMPORT_FROM_STUDIES_SUCCESS = 'IMPORT_FROM_STUDIES_SUCCESS';
export const IMPORT_FROM_STUDIES_FAIL = 'IMPORT_FROM_STUDIES_FAIL';
export const IMPORT_FROM_STUDIES_RESET = 'IMPORT_FROM_STUDIES_RESET';

export const getEligibleStudiesSuccess = (response) => ({
  type: GET_ELIGIBLE_STUDIES_SUCCESS,
  response,
});

export const getEligibleStudiesFail = (response) => ({
  type: GET_ELIGIBLE_STUDIES_FAIL,
  response,
});

export const getEligibleStudiesReset = () => ({
  type: GET_ELIGIBLE_STUDIES_RESET,
});

export const importFromStudiesSuccess = (response) => ({
  type: IMPORT_FROM_STUDIES_SUCCESS,
  response,
});

export const importFromStudiesFail = (response) => ({
  type: IMPORT_FROM_STUDIES_FAIL,
  response,
});

export const importFromStudiesReset = () => ({
  type: IMPORT_FROM_STUDIES_RESET,
});

export const getEligibleStudiesForImportApi = (projectId) => {
  return (dispatch) => {
    dispatch({ type: GET_ELIGIBLE_STUDIES });
    return axios
      .get(`${config.api.base_url}/projects/${projectId}/eligible-studies`, {
        headers: {
          Authorization: 'Bearer ' + getUserToken(),
        },
      })
      .then((response) => {
        dispatch(getEligibleStudiesSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(getEligibleStudiesFail(error.response?.data || error.message));
        throw error;
      });
  };
};

export const importFromStudiesApi = (projectId, studyIds, batchTag = null) => {
  return (dispatch) => {
    dispatch({ type: IMPORT_FROM_STUDIES });
    return axios
      .post(
        `${config.api.base_url}/projects/${projectId}/import-from-studies`,
        { studyIds, batchTag },
        {
          headers: {
            Authorization: 'Bearer ' + getUserToken(),
          },
        }
      )
      .then((response) => {
        dispatch(importFromStudiesSuccess(response.data));
        return response.data;
      })
      .catch((error) => {
        dispatch(importFromStudiesFail(error.response?.data || error.message));
        throw error;
      });
  };
};

// Get project history (non-redux, simple fetch)
export const getProjectHistoryApi = async (projectId, page = 1, limit = 10) => {
  const response = await axios.get(
    `${config.api.base_url}/projects/${projectId}/history?page=${page}&limit=${limit}`,
    {
      headers: {
        Authorization: 'Bearer ' + getUserToken(),
      },
    }
  );
  return response.data;
};
